import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireLocalizedFormat } from "../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/localizedFormat.js";
var localizedFormatExports = requireLocalizedFormat();
const localizedFormat = /* @__PURE__ */ getDefaultExportFromCjs(localizedFormatExports);
export {
  localizedFormat as default
};
//# sourceMappingURL=localizedFormat.js.map
